<template>
    <div class="lg:w-1/2 sm:w-full text-center" id="scroll-to-multiselect">
        <p class="mb-1" v-text="label"></p>
        <multiselect
            v-model="question"
            :custom-label="contentForSearch"
            :options="faqAnswers"
            :searchable="true"
            :allow-empty="false"
            :multiple="false"
            :show-labels="false"
            openDirection="below"
            placeholder="Type keywords to find answers"
            @search-change="handleSearchChange"
            @input="handleSelect">

            <!-- A single label is shown after pressing Enter -->
            <template slot="singleLabel" slot-scope="{ option }">
                <div class="option__desc">
                    <span class="option__title" v-text="option.title"></span>
                </div>
            </template>

            <!-- An option is shown while typing -->
            <template slot="option" slot-scope="{ option }">
                <div class="option__desc">
                    <span class="option__title" v-text="option.title"></span>
                </div>
            </template>

            <template slot="noResult" v-text="$t('FAQ_SEARCH_SORRY')"></template>
        </multiselect>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import FaqService from '@/services/faq/FaqService';

let faqService = new FaqService();

export default {
    name: 'FaqSearch',
    components: { Multiselect },
    props: {
        label: {
            required: true,
            type: String,
        },
    },
    mounted: function() {
        this.getSearchQuestions();
    },
    data() {
        return {
            question: '',
            faqAnswers: [],
        };
    },
    computed: {
        ...mapGetters({
            isUserLoggedIn: 'auth/isUserLoggedIn',
            pauseEnabled: 'account/getAllowPaused',
        }),
        includePauseQuestions() {
            return this.isUserLoggedIn && this.pauseEnabled;
        },
    },
    methods: {
        contentForSearch: ({ title, answer }) => `${title} ${answer}`,

        getSearchQuestions() {
            faqService.getSearchQuestions().then((answers) => {
                const filteredByAuthStatus = answers.filter(item => item.loggedIn === this.isUserLoggedIn);
                const filteredPauseQuestions = filteredByAuthStatus.filter(item => {
                    const includeQuestion = this.includePauseQuestions ? true : !item.pauseEnabled;
                    return includeQuestion;
                });
                this.faqAnswers = filteredPauseQuestions;
            });
        },

        handleSelect() {
            this.$router.push(this.question.path);
        },

        handleSearchChange(searchQuery) {
            if (searchQuery.length) {
                faqService.getUniqQuestions().then((answers) => {
                    const filteredByAuthStatus = answers.filter(item => item.loggedIn === this.isUserLoggedIn);
                    const filteredPauseQuestions = filteredByAuthStatus.filter(item => {
                        const includeQuestion = this.includePauseQuestions ? true : !item.pauseEnabled;
                        return includeQuestion;
                    });
                    this.faqAnswers = filteredPauseQuestions;
                });
            } else {
                this.getSearchQuestions();
            }
        },
    },
};
</script>
